module.exports = __webpack_public_path__ + "img/in_tooth_washer.prt.ce85ffb9.jpg";